import React from 'react';
import {Link, LinkProps} from 'react-router-dom';

export const LLLink = (props: LinkProps) => {
	const {className, ...rest} = props;
	const sx = {
		root: {
			textDecoration: 'none',
		},
	};
	return <Link {...rest} className={className} style={sx.root}/>;
};
